// extracted by mini-css-extract-plugin
module.exports = {"separator":"PaymentSummaryItemsList_separator__5T0m6"};